/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxRedemptionTransactionHistoryResponsePagination
 */
export interface LootboxRedemptionTransactionHistoryResponsePagination {
    /**
     * Total number of LootBox redemptions
     * @type {number}
     * @memberof LootboxRedemptionTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof LootboxRedemptionTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof LootboxRedemptionTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof LootboxRedemptionTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the LootboxRedemptionTransactionHistoryResponsePagination interface.
 */
export function instanceOfLootboxRedemptionTransactionHistoryResponsePagination(value: object): value is LootboxRedemptionTransactionHistoryResponsePagination {
    return true;
}

export function LootboxRedemptionTransactionHistoryResponsePaginationFromJSON(json: any): LootboxRedemptionTransactionHistoryResponsePagination {
    return LootboxRedemptionTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxRedemptionTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function LootboxRedemptionTransactionHistoryResponsePaginationToJSON(json: any): LootboxRedemptionTransactionHistoryResponsePagination {
    return LootboxRedemptionTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryResponsePaginationToJSONTyped(value?: LootboxRedemptionTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

